// This import loads the firebase namespace along with all its type information.
import ProfileRole from './profile-role-model'

export async function load_profileRoles(): Promise<ProfileRole[]> {
  throw 'Not implemented'
}

export async function delete_profileRole(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_profileRole(): Promise<ProfileRole> {
  throw 'Not implemented'
}
